import { render, staticRenderFns } from "./PortablesStats.vue?vue&type=template&id=e36a0092&"
import script from "./PortablesStats.vue?vue&type=script&lang=js&"
export * from "./PortablesStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\270b-ariq\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e36a0092')) {
      api.createRecord('e36a0092', component.options)
    } else {
      api.reload('e36a0092', component.options)
    }
    module.hot.accept("./PortablesStats.vue?vue&type=template&id=e36a0092&", function () {
      api.rerender('e36a0092', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/rd/PortablesStats.vue"
export default component.exports